var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimelapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "70.05 -0.02 559.94 559.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.31 1.668c-71.469 8.3125-137.83 43.758-183.48 98.305-71.031 84.742-85.762 201.57-38.215 300.9 28.148 58.488 73.074 103.41 131.41 131.41 99.473 47.695 216.3 32.965 301.05-38.066 62.863-52.508 99.91-132.14 99.91-214.12 0-81.969-37.047-161.61-99.91-214.12-58.344-49.008-136.67-72.781-210.76-64.32zm141.48 167.3v55.133l-42.297 30.336c-23.191 16.773-42.297 30.922-42.297 31.504s19.105 14.73 42.297 31.504l42.297 30.336v98.602h-218.78l0.29297-50.613 0.4375-50.465 40.109-28.879c22.023-15.898 40.109-29.609 40.109-30.484s-18.086-14.586-40.109-30.484l-40.109-28.879-0.4375-56.301-0.29297-56.445h218.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimelapse);
export default __webpack_public_path__ + "static/media/icon-timelapse.38f76621cd4f033fde6e263a121d4b03.svg";
export { ForwardRef as ReactComponent };